import { IApplicationState } from '../../types/redux';
import { TUserAnalytics } from '../../types/currentUser';

export const getUserForAnalytics = (state: IApplicationState): TUserAnalytics => {
  const { user } = state;

  if (user.isAuthenticated) {
    return {
      type: user.userType,
      email: user.email ? user.email : '',
      cianUserId: user.id as number,
      userId: user.userId as number,
    };
  }

  return {
    type: 'not_authorized',
  };
};
